import styled from "styled-components";
import Container from "../../atoms/Container/Container.styled";
import {
  withAnchorOffset,
  withDisplayHeading,
  withSectionSpacing,
} from "../../../themes/mixins";
import { deviceMax } from "../../../utils/device";

export const WorkflowSection = styled.section`
  ${withSectionSpacing()};
  ${withAnchorOffset()};
  background: ${({ theme }) => theme.colors.white};
`;

export const WorkflowWrapper = styled(Container)``;

export const WorkflowIntro = styled.div`
  align-items: flex-end;
  display: flex;
  gap: 70px;
  justify-content: space-between;
  margin-bottom: 48px;

  @media ${deviceMax.tabletWideMax} {
    align-items: flex-start;
    gap: 35px;
    margin-bottom: 33px;
  }

  @media ${deviceMax.phoneMax} {
    display: block;
    margin-bottom: 29px;
  }
`;

export const WorkflowTitle = styled.h2`
  ${withDisplayHeading()};
  max-width: 625px;

  @media ${deviceMax.tabletWideMax} {
    font-size: 33px;
  }

  @media ${deviceMax.phoneMax} {
    font-size: 34px;
    max-width: 430px;
  }
`;

export const StepGrid = styled.div`
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(3, 1fr);

  @media ${deviceMax.tabletWideMax} {
    gap: 15px;
  }

  @media ${deviceMax.phoneMax} {
    gap: 14px;
    grid-template-columns: 1fr;
  }
`;

